import { LoginComponent } from "@/features";

export const LoginPage = () => {
  return <LoginComponent />;
}